import React, { useState } from 'react';

function ImportPage() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const products = [
    {
      title: "Dates",
      desc: "High-quality, naturally sweet dates sourced from premium harvests. Rich in fiber, minerals, and antioxidants — ideal for direct consumption, confectionery, and bulk food supply chains.",
      image: "https://tse4.mm.bing.net/th/id/OIP.hLz7y4HH9ZjZat4Qqa2SpgHaHa?w=1024&h=1024&rs=1&pid=ImgDetMain&o=7&rm=3"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-teal-50/30 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Title with Animation */}
        <div className="text-center mb-16 animate-fade-in-down">
          <div className="inline-block mb-4">
            <div className="w-20 h-1 bg-teal-400 rounded-full mb-2 animate-pulse"></div>
            <div className="w-16 h-1 bg-teal-300 rounded-full animate-pulse" style={{animationDelay: '0.3s'}}></div>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 transform transition-all duration-700 hover:scale-105">
            <span className="text-gray-800">IMPORT</span>{" "}
            <span className="text-amber-500  animate-pulse-slow">
              PRODUCTS
            </span>
          </h1>
          
          <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in-up">
            Discover our premium range of imported products sourced from the finest global producers
          </p>
        </div>

        {/* Products Grid - Centered */}
        <div className="flex justify-center items-center mb-16">
          <div className="max-w-md w-full">
            {products.map((product, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-500 hover:shadow-2xl hover:-translate-y-3 border border-gray-100 hover:border-teal-300 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
                onMouseEnter={() => setHoveredCard(index)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                {/* IMAGE CONTAINER WITH OVERLAY */}
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                  />
                  
                  {/* Gradient Overlay */}
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-all duration-500`}></div>
                </div>

                {/* TEXT CONTENT */}
                <div className="p-6 relative">
                  {/* Background Pattern */}
                  <div className="absolute top-0 right-0 w-20 h-20 bg-teal-100 rounded-full -translate-y-1/2 translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  
                  <h3 className="text-xl font-bold text-gray-800 mb-3 relative z-10 transform transition-all duration-300 group-hover:text-teal-600 group-hover:translate-x-2">
                    {product.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed relative z-10 transform transition-all duration-500 group-hover:text-gray-700">
                    {product.desc}
                  </p>

                  {/* View More Button */}
                  <div className={`mt-4 transform transition-all duration-500 ${
                    hoveredCard === index ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
                  }`}>
                    {/* Button content can be added here */}
                  </div>
                </div>

                {/* Animated Border Bottom */}
                <div className={`h-1 bg-gradient-to-r from-teal-400 to-teal-600 transform origin-left transition-transform duration-500 ${
                  hoveredCard === index ? 'scale-x-100' : 'scale-x-0'
                }`}></div>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Add CSS Animations */}
      <style>{`
        @keyframes fade-in-down {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse-slow {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }
        
        .animate-fade-in-down {
          animation: fade-in-down 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
          opacity: 0;
        }
        
        .animate-pulse-slow {
          animation: pulse-slow 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default ImportPage;